import React, { useEffect, useRef, useState } from "react";
import { Button } from "./ui.tsx";
import "./complete-preview.css";
export function CompletePreview({
  go,
  officeAllowed,
  visitsAllowed,
  demandAllowed,
  calendarAllowed,
}: {
  go: (page: string) => void;
  officeAllowed: boolean;
  visitsAllowed: boolean;
  demandAllowed: boolean;
  calendarAllowed: boolean;
}) {
  const frame = useRef<HTMLIFrameElement>(null);
  const [size, setSize] = useState("auto"),
    [loading, setLoading] = useState(true),
    [notice, setNotice] = useState("");
  useEffect(() => {
    const receive = (event: MessageEvent) => {
      if (
        event.source !== frame.current?.contentWindow ||
        event.origin !== "null" ||
        event.data?.type !== "gabinete-preview-open"
      )
        return;
      const view = event.data.view;
      if (view === "offices" && officeAllowed) go("offices");
      else if (view === "visits-overview" && visitsAllowed)
        go("visits-overview");
      else
        setNotice(
          "A prévia não altera suas permissões. Este módulo funcional precisa ser liberado pelo administrador.",
        );
    };
    window.addEventListener("message", receive);
    return () => window.removeEventListener("message", receive);
  }, [go, officeAllowed, visitsAllowed]);
  return (
    <main className="complete-preview">
      <header className="complete-preview-header">
        <div>
          <strong>Prévia completa do Gabinete Central</strong>
          <p>
            Todos os módulos visuais · dados demonstrativos, sem gravação no
            sistema.
          </p>
        </div>
        <Button onClick={() => go("home")}>Voltar ao sistema</Button>
      </header>
      <nav
        className="complete-preview-tools"
        aria-label="Prévia e módulos funcionais"
      >
        <label>
          Exibição{" "}
          <select value={size} onChange={(e) => setSize(e.target.value)}>
            <option value="auto">Tela inteira</option>
            <option value="mobile">Celular</option>
          </select>
        </label>
        <span>Abrir módulos funcionais:</span>
        {demandAllowed && (
          <Button onClick={() => go("demands")}>Demandas</Button>
        )}
        {calendarAllowed && (
          <Button onClick={() => go("calendar")}>Calendário</Button>
        )}
        {officeAllowed && (
          <Button className="preview-office-link" onClick={() => go("offices")}>
            Ofícios atuais
          </Button>
        )}
        {visitsAllowed && (
          <Button onClick={() => go("visits-overview")}>
            Consulta de visitas
          </Button>
        )}
      </nav>
      {notice && (
        <p className="complete-preview-notice" role="status">
          {notice}
        </p>
      )}
      {loading && <p role="status">Carregando a prévia completa…</p>}
      <div className={"complete-preview-stage " + size}>
        <iframe
          ref={frame}
          title="Todos os módulos — prévia visual demonstrativa"
          src="/api/preview/complete"
          sandbox="allow-scripts allow-forms allow-modals allow-downloads"
          onLoad={() => setLoading(false)}
        />
      </div>
    </main>
  );
}
